// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"_1ZTRSWTbJyAPxp98IgXTnK","photo":"_1WdCV67cxCrQ0ECcY8K-fm","infoContainer":"_1MpY0pXscyjZhIYoSXm2l8","username":"_20lBIHk2rGuRUNB50FHF5n","state":"pPa6sjdvQ-cKkx9dmtw-H","lastTimeSeen":"iG3IdjJ6bU-oVYoa_PQcd","mainContainerDarkTheme":"_2mwtpk9BkJ_fMYYuuye_vo"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/chat/conversations/user-card/UserCard.css
// module id = 251
// module chunks = 0